import React, { useEffect, useState } from "react";
import { toJS } from "mobx";
import { observer } from "mobx-react";
import nsi from "../../../../store/nsi";
import { Row, Col } from "antd";
import { Controller, useFieldArray } from "react-hook-form";
import classNames from "classnames";
import { authStore } from "../../../../store/authStore";
import {
  FormField,
  IDatePicker,
  ICheckbox,
  ISelect,
  UploadFile,
  AutoComplete,
  FormBlock,
  Skeleton,
} from "../../../../ui-kit";

import { EVENT_TYPE_PLANNING_ID } from "../../constants";

import { IResourceFormData } from "../../interface";
import styles from "../../DefectForm.module.scss";
import AddressDisconnexion, {
  emptyAddressDisconnexion,
  TAddressDisconnexion,
} from "../addressDisconnexion";
import { PlusOutlined } from "@ant-design/icons";
const { SelectSkeleton } = Skeleton;

const PowerSupplyForm: React.FC<IResourceFormData> = observer(
  ({
    isAddMode,
    isClose,
    isReadonly,
    onChangeImage,
    setAddressInfo,
    data,
    RSOList,
    ...handleForm
  }) => {
    const { register, setValue, watchAllField, errors, control } = handleForm;

    const {
      fields: addressDisconnexionFields,
      append: appendAddressDisconnexion,
      remove: removeAddressDisconnexion,
    } = useFieldArray({
      control,
      name: "addressDisconnexionList",
    });

    const { defectNotify } = authStore;

    const [editRSO, setEditRSO] = useState<boolean>(false);

    useEffect(() => {
      // findorg().then((res) => {
      //   setEditRSO(res.toLowerCase().includes('комитет') || res.toLowerCase().includes('сспк') || orgId == 9999999)
      // });
      //setEditRSO(organizationName.toLowerCase().includes('комитет') || organizationName.toLowerCase().includes('сспк') || orgId == 9999999)
      setEditRSO(authStore.allOrgsView);
    }, []);

    const changeSelectPlaceOfWorkText = (_, { id = "" }) => {
      setValue("placeOfWorkGuid", id);
    };

    const clearPlaceOfWork = () => {
      setValue("placeOfWorkText", "");
      setValue("placeOfWorkGuid", "");
    };

    const fiasTooltip = (
      <>
        <div>
          Начните вводить адрес с улицы и выберите значение из списка. Например:
        </div>
        <div>
          - фонтанка (для адреса г Санкт-Петербург, наб Реки Фонтанки, д 172)
        </div>
        <div>
          - линия (для адреса г Санкт-Петербург, г Сестрорецк, 9-я линия, д 6
          стр 1)
        </div>
        <div>- советская 9 (г Санкт-Петербург, ул 9-я Советская, д 3)</div>
        <div>
          - большой пр-кт (для адреса г Санкт-Петербург, пр-кт Большой В.О., д
          92 литера Г)
        </div>
        <div>
          - угловые дома - ломоносова 37/8: (для адреса г Санкт-Петербург, город
          Красное Село, ул Ломоносова, д 37/8 литера А)
        </div>
        <div>
          - 197729 (ввод индекса для поселков и н.п., г Санкт-Петербург, поселок
          Молодежное, ул Правды, д 3б)
        </div>
      </>
    );

    return (
      <div className={styles.fieldsWrap}>
        <div className={styles.fieldContainer}>
          {nsi.orgIsLoading.value ? (
            <SelectSkeleton />
          ) : (
            <Controller
              control={control}
              name="organizationId"
              render={({ field }) => (
                <ISelect
                  field={field}
                  optionsArr={RSOList}
                  placeholder="Ресурсоснабжающая организация"
                  disabled={!editRSO || isReadonly}
                  error={errors?.organizationId?.message}
                  isRequired
                />
              )}
            />
          )}
          <FormField
            label={
              watchAllField.eventTypeId === EVENT_TYPE_PLANNING_ID
                ? "ID планового события"
                : "ID дефекта"
            }
            name="externalId"
            register={register}
            type="number"
            currentValue={watchAllField.externalId}
            error={errors?.externalId?.message}
            registerOptions={{
              valueAsNumber: true,
            }}
            isRequired
            disabled={isReadonly}
          />
          <Controller
            control={control}
            name="eventTypeId"
            render={({ field }) => (
              <ISelect
                field={field}
                optionsArr={nsi.eventTypes}
                placeholder="Тип события"
                error={errors?.eventTypeId?.message}
                isRequired
                disabled={isReadonly}
              />
            )}
          />
          <FormBlock
            name="Дата и время отключения/ограничения"
            disabled={isReadonly}
          >
            <Row gutter={22}>
              <Col span={12}>
                <Controller
                  control={control}
                  name="dateTimeDisable"
                  render={({ field }) => (
                    <IDatePicker
                      field={field}
                      placeholder={"Дата"}
                      error={errors?.dateTimeDisable?.message}
                      isRequired
                    />
                  )}
                />
              </Col>
              <Col span={12}>
                <FormField
                  label="Время"
                  name="timeDisable"
                  register={register}
                  type="time"
                  currentValue={watchAllField?.timeDisable}
                  error={errors?.timeDisable?.message}
                  isRequired
                />
              </Col>
            </Row>
          </FormBlock>
          <Controller
            control={control}
            name="addressText"
            render={({ field }) => (
              <AutoComplete
                field={field}
                info={fiasTooltip}
                label={
                  watchAllField.eventTypeId === EVENT_TYPE_PLANNING_ID
                    ? "Адрес планового события"
                    : "Адрес дефекта"
                }
                error={errors?.addressGuid?.message}
                required
                onSelect={(value: any) => {
                  setAddressInfo(value);
                  clearPlaceOfWork();
                }}
                onChange={(value) => {
                  if (!value) setAddressInfo(null);
                }}
                disabled={isReadonly}
              />
            )}
          />
          <Controller
            control={control}
            name="districtId"
            render={({ field }) => (
              <ISelect
                field={field}
                optionsArr={nsi.districts}
                onChange={watchAllField.districtId}
                placeholder="Административный район"
                error={errors?.districtId?.message}
                isRequired
                disabled={isReadonly}
              />
            )}
          />

          <FormField
            label="Примечание к адресу"
            name="addressNote"
            register={register}
            type="text"
            currentValue={watchAllField.addressNote}
            disabled={isReadonly}
          />
          <FormBlock
            name="Адреса отключаемых зданий или с ограничениями по ЦО"
            disabled={isReadonly}
          >
            <button
              className={styles.addButton}
              onClick={(e) =>
                appendAddressDisconnexion({ ...emptyAddressDisconnexion })
              }
              type="button"
            >
              <PlusOutlined style={{ fontSize: "24px", color: "#fff" }} />{" "}
              <span>Добавить адрес</span>
            </button>
            {addressDisconnexionFields.map((address, index) => {
              return (
                <AddressDisconnexion
                  key={address.id}
                  control={control}
                  addressDisconnexion={
                    watchAllField.addressDisconnexionList[
                      index
                    ] as TAddressDisconnexion
                  }
                  index={index}
                  setValue={setValue}
                  removeAddressDisconnexion={removeAddressDisconnexion}
                  required={!isClose}
                />
              );
            })}
          </FormBlock>
        </div>
        <div className={styles.fieldContainer}>
          <FormField
            label="Количество отключенных абонентов"
            name="disconnectedSubscribers"
            register={register}
            type="number"
            currentValue={watchAllField.disconnectedSubscribers}
            disabled={isReadonly}
          />

          <FormBlock
            name={
              watchAllField.eventTypeId === EVENT_TYPE_PLANNING_ID
                ? "Описание планового события"
                : "Описание дефекта"
            }
            disabled={isReadonly}
          >
            <Row gutter={22}>
              <Col span={24}>
                <Controller
                  control={control}
                  name="placeOfWorkText"
                  render={({ field }) => (
                    <AutoComplete
                      field={field}
                      label="Место работ"
                      onChange={changeSelectPlaceOfWorkText}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row gutter={22}>
              <Col span={24}>
                <Controller
                  control={control}
                  name="lightingProblemTypeId"
                  render={({ field }) => (
                    <ISelect
                      field={field}
                      optionsArr={nsi.lightingProblemTypes}
                      placeholder={"Характер неисправности"}
                      disabled={isReadonly}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row gutter={22}>
              <Col span={24}>
                <Controller
                  control={control}
                  name="producedWorkId"
                  render={({ field }) => (
                    <ISelect
                      field={field}
                      optionsArr={nsi.producedWorks}
                      placeholder={"Произведенная работа"}
                      disabled={isReadonly}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row gutter={22}>
              <Col span={24}>
                <Controller
                  control={control}
                  name="workTypeId"
                  render={({ field }) => (
                    <ISelect
                      field={field}
                      optionsArr={nsi.workTypes}
                      placeholder={"Вид работ"}
                      disabled={isReadonly}
                    />
                  )}
                />
              </Col>
            </Row>
            <Row gutter={22}>
              <Col span={24}>
                <FormField
                  label="Уточнение вида работ"
                  name="clarifiedWorkType"
                  register={register}
                  type="text"
                  currentValue={watchAllField.clarifiedWorkType}
                  disabled={isReadonly}
                />
              </Col>
            </Row>
          </FormBlock>
        </div>
        <div className={styles.fieldContainer}>
          <FormBlock name="Дата и время начала работ" disabled={isReadonly}>
            <Row gutter={22}>
              <Col span={12}>
                <Controller
                  control={control}
                  name="dateTimeWorkStarted"
                  render={({ field }) => (
                    <IDatePicker
                      field={field}
                      placeholder={"Дата"}
                      error={errors?.dateTimeWorkStarted?.message}
                      isRequired
                    />
                  )}
                />
              </Col>
              <Col span={12}>
                <FormField
                  label="Время"
                  name="lightingWorkStartedTime"
                  register={register}
                  type="time"
                  currentValue={watchAllField.lightingWorkStartedTime}
                  error={errors?.lightingWorkStartedTime?.message}
                  isRequired
                />
              </Col>
            </Row>
          </FormBlock>

          <FormBlock
            name={
              watchAllField.eventTypeId === EVENT_TYPE_PLANNING_ID
                ? "Дата и время завершения планового события"
                : "Дата и время устранения дефекта"
            }
            disabled={isReadonly}
          >
            <Row gutter={22}>
              <Col span={12}>
                <Controller
                  control={control}
                  name="dateTimeEnable"
                  render={({ field }) => (
                    <IDatePicker
                      field={field}
                      placeholder={"Дата"}
                      error={errors?.dateTimeEnable?.message}
                      isRequired={isClose}
                    />
                  )}
                />
              </Col>
              <Col span={12}>
                <FormField
                  label="Время"
                  name="timeEnable"
                  register={register}
                  type="time"
                  currentValue={watchAllField?.timeEnable}
                  error={errors?.timeEnable?.message}
                  isRequired={isClose}
                />
              </Col>
            </Row>
          </FormBlock>

          <FormField
            label="ФИО ответственного"
            name="responsible"
            register={register}
            type="text"
            currentValue={watchAllField.responsible}
            error={errors?.responsible?.message}
            isRequired
            disabled={isReadonly}
          />

          <FormField
            label="Телефон ответственного"
            name="responsiblePhone"
            register={register}
            type="tel"
            currentValue={watchAllField.responsiblePhone}
            error={errors?.responsiblePhone?.message}
            isRequired
            disabled={isReadonly}
          />

          <FormField
            label="Комментарий"
            name="comment"
            register={register}
            type="text"
            currentValue={watchAllField.comment}
            disabled={isReadonly}
          />

          <UploadFile
            onChange={onChangeImage}
            accept="image"
            label="Загрузить файл"
            files={toJS(data?.files)}
            isDisabled={isReadonly}
          />

          {authStore && defectNotify && (
            <div className={styles.form__container}>
              <Controller
                control={control}
                name="mediaCoverage"
                render={({ field: { value, onChange } }) => (
                  <>
                    <ICheckbox
                      checked={value}
                      onChange={onChange}
                      label={"Признак СМИ"}
                      className={classNames(styles.form__checkBoxTitle, {
                        [styles.form__checked]: value,
                      })}
                      disabled={isReadonly}
                    />
                    {value && (
                      <div className={styles.form__item}>
                        <Row gutter={[0, 22]}>
                          <FormField
                            label="Комментарий СМИ"
                            name="mediaComment"
                            register={register}
                            type="textarea"
                            currentValue={watchAllField.mediaComment}
                            error={errors?.mediaComment?.message}
                            disabled={isReadonly}
                          />
                        </Row>
                      </div>
                    )}
                  </>
                )}
              />
            </div>
          )}
        </div>
      </div>
    );
  },
);

export default PowerSupplyForm;
